import { render, staticRenderFns } from "./rascunhos.vue?vue&type=template&id=3616c3ed&scoped=true&"
import script from "./rascunhos.vue?vue&type=script&lang=js&"
export * from "./rascunhos.vue?vue&type=script&lang=js&"
import style0 from "./rascunhos.vue?vue&type=style&index=0&id=3616c3ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3616c3ed",
  null
  
)

export default component.exports